// Query param the login popup sends to /auth/login with the page that started login.
export const AUTH_RETURN_PATH_PARAM = 'return_path';

// Query param on /login-success and /signup-success that carries that page back after Auth0.
export const AUTH_NEXT_PARAM = 'next';

// The URL parser drops tabs, carriage returns and newlines and treats `\` as `/`, so `/<tab>/host` or
// `/\host` would navigate off-site. Real paths never contain these: `location` percent-encodes them.
const hasUnsafeCharacter = (value: string): boolean =>
	[...value].some(character => {
		const code = character.charCodeAt(0);
		return code <= 0x20 || code === 0x7f || character === '\\';
	});

// Returning to a success page or an auth route would land on this same redirect again.
const isAuthRoute = (path: string): boolean =>
	/^\/(login-success|signup-success|auth)(?=[/?#]|$)/i.test(path);

// Only same-site relative paths are accepted. A protocol-relative `//host` or an absolute URL
// would turn the post-login redirect into an open redirect, since anyone can link to the success pages.
export const isSafeReturnPath = (value: unknown): value is string =>
	typeof value === 'string' &&
	value.startsWith('/') &&
	!value.startsWith('//') &&
	!hasUnsafeCharacter(value) &&
	!isAuthRoute(value);
